import React from 'react';
import FadeLoader from "react-spinners/FadeLoader";

export default function Loading(props){

 
    function renderLoading (){
        if (props.loading == true) 
        return (
        // <div style={{color:'darkgreen', textAlign:'center', fontSize:20}}>Loading...</div>
        <div style={{textAlign:'center',  fontSize:20}}><FadeLoader color={'steelblue'} loading={props.loading}  size={20} /></div>
        
        );
      }

    return(
        <div>
        {renderLoading()}
        </div>
    ); 
}